module.exports = __webpack_public_path__ + "img/plane.50a51470.png";